import React, { useState } from 'react'
import AskVisoPrompt from './AskVisoPrompt'
import { Select } from '../../../../containers/CustomDashboard/Dashboard/details/editor/inputs/Select'
import { MultiSelect } from '../../../../containers/CustomDashboard/Dashboard/details/editor/inputs/MultiSelect'
import { CAMERA_SOURCE_OPTIONS, CAMERA_COUNT_OPTIONS, KEY_TASK_OPTIONS, OUTPUT_OPTIONS, COUNT_TYPE_OPTIONS } from '../../constants'
import './AskVisoInsertFlows.scss'
import AskVisoSuggestions from './AskVisoSuggestions'
import Comment, { CommentBubble } from '../../../Comment/index'

const outputValues = {
  'Dashboard': 'dashboard',
  'Incidents': 'incidents',
}

const AskVisoInsertFlows = ({ message = {}, color, contextType, onAskAgent, setOutputType, outputType, setPromptValue, promptValue, setModelType, modelType, isFullscreen, isLoading, onInsertFlow, isNewFlow, setActiveContent, mode, onModeChange, chatId }) => {

  const [chartRequest, setChartRequest] = useState('')
  const [prompt, setPrompt] = useState([])
  const [formValues, setFormValues] = useState({
    trackingEnabled: KEY_TASK_OPTIONS[0].value,
    streamCount: CAMERA_COUNT_OPTIONS[0].value,
    videoSourceType: CAMERA_SOURCE_OPTIONS[0].value,
    outputs: [],
    countType: COUNT_TYPE_OPTIONS[0].value,
  })

  const [keyTask, setKeyTask] = useState('')
  const handleChange = (value) => {
    const updateValues = { ...formValues, ...value }
    // const promptValue = 'The flow consists of three nodes:\n1. A “multiple object detection”\n2. A function node called “ABC”\n3. A debug node for the output.\nThe nodes are arranged left to right. Click below to add.'

    setFormValues(updateValues)
    // setChartRequest(promptValue)
  }

  const onSubmit = () => {
    setPrompt([
      {
        senderRole: 'user',
        content: chartRequest,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
      {
        senderRole: 'model',
        content: 'The dashboard consists of two charts, showing data over the last 30 days:\n\n1. A stacked bar chart, to breakdown the error_rate over the active time interval, grouped by service-category\n\n2. A table showing top 10 regions by average incident rate over the active time interval, grouped by region.',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      }
    ])
    setChartRequest('')
  }

  const onInsert = () => {
    // setActiveContent('chat')
    let payload = {
      trackingEnabled: formValues.trackingEnabled,
      streamCount: formValues.streamCount,
      videoSourceType: formValues.videoSourceType,
      outputs: formValues.outputs.map(item => outputValues[item.value]),
    }

    if (keyTask === 'Counting') {
      payload.countType = formValues.countType
    }

    onInsertFlow(payload)
  }

  return (
    <div className='ask-viso-insert-flow'>
      <div className='ask-viso-insert-flow__content'>
        <Comment
          contentClass='ask-viso-chat__comment'
          showAvatar
          hideName
          firstName='A'
          lastName='I'
          color={color}
          text={
            <div className='ask-viso-insert-flow__form'>
              <div className='ask-viso-insert-flow__title'>Please provide additional information needed to build a first application version for you.</div>
              <div className='border-left'>
                <Select
                  label='Input Streams'
                  selectedOption={CAMERA_COUNT_OPTIONS.find(option => option.value === formValues.streamCount)}
                  options={CAMERA_COUNT_OPTIONS}
                  onChange={(value) => handleChange({ streamCount: value.value })}
                />
                <Select
                  label='Camera Type'
                  selectedOption={CAMERA_SOURCE_OPTIONS.find(option => option.value === formValues.videoSourceType)}
                  onChange={(value) => handleChange({ videoSourceType: value.value })}
                  options={CAMERA_SOURCE_OPTIONS}
                />
                <Select
                  label='Key Task'
                  selectedOption={KEY_TASK_OPTIONS.find(option => option.value === formValues.trackingEnabled)}
                  options={KEY_TASK_OPTIONS}
                  onChange={(value) => {
                    handleChange({ trackingEnabled: value.value })
                    setKeyTask(value.label)
                  }}
                />
                {keyTask === 'Counting' && <Select
                  label='Count Type'
                  hasBorder
                  selectedOption={COUNT_TYPE_OPTIONS.find(option => option.value === formValues.countType)}
                  options={COUNT_TYPE_OPTIONS}
                  onChange={(value) => handleChange({ countType: value.value })}
                />}
                <MultiSelect
                  withSimpleMenu
                  label='Output'
                  selectedOptions={formValues.outputs}
                  options={OUTPUT_OPTIONS}
                  showSelectedOptions={true}
                  onChange={(values) => {
                    handleChange({
                      outputs: values
                    })
                  }}
                />
              </div>
            </div>
          }
          commentFooter={
            <>
              {message?.content?.reasoning && showReasoning && (
                <div className='ask-viso-chat-message__reasoning border-left'>
                  <ol>{message.content.reasoning.map((reason, index) => (<li key={index}>{reason}</li>))}
                  </ol>
                </div>
              )}
              {message?.content?.suggestions && message?.content?.suggestions?.length > 0 &&
                <AskVisoSuggestions
                  suggestions={message?.content?.suggestions}
                  chatId={chatId}
                  isFullscreen={isFullscreen}
                  setPromptValue={setPromptValue}
                  color={color}
                  isFooter
                />
              }
            </>
          }
        />

        <div className='ask-viso-insert-flow__insert'>
          <button
            className='ask-viso-insert-flow__button ask-viso-insert-flow__button_accent3'
            onClick={onInsert}
          >
            Insert Flow
          </button>
        </div>

      </div>

      {/* <div className='ask-viso-prompt ask-viso-prompt--welcome'> */}
        <AskVisoPrompt
          onAskAgent={onAskAgent}
          color={'accent3'}
          contextType={contextType}
          isLoading={isLoading}
          setMode={onModeChange}
          mode={mode}
          setPromptValue={setPromptValue}
          promptValue={promptValue}
          setModelType={setModelType}
          modelType={modelType}
          isFullscreen={isFullscreen}
          setOutputType={setOutputType}
          outputType={outputType}
          isNewFlow={isNewFlow}
          chatId={chatId}
        />
      {/* </div> */}
              {/* <div className='ask-viso-prompt__suggestions'>
                {mockSuggestions.map((suggestion, index) => (
                  <ChipDropdown
                    key={index}
                    label={suggestion}
                    color='outline'
                    background='body-bg'
                    labelOnly
                    onClick={() => setPromptValue(suggestion)}
                  />
                ))}
              </div> */}

    </div>
  )
}

export default AskVisoInsertFlows
